<div class="row w100 space-between align-end">
    <span class="inputlabel" *ngIf="label !== ''"
        >{{ label }}<span *ngIf="required" class="color-weak"> *</span></span
    >
    <span class="color-weak" *ngIf="limitCharacters !== undefined">
        Characters: {{ FormControl.value?.length || 0 }} / {{ limitCharacters }}
    </span>
    <rr-btn
        *ngIf="btnType"
        [iconStart]="btnIconStart"
        [iconEnd]="btnIconEnd"
        [disabled]="btnDisabeld"
        [type]="btnType"
        size="small"
        (click)="onBtnClick()"
        >{{ btnText }}</rr-btn
    >
</div>
<div
    *ngIf="FormControl.invalid && (FormControl.dirty || FormControl.touched)"
    class="input-error"
>
    <rr-icon name="octagon"></rr-icon>
    <span *ngIf="FormControl.hasError('required')" i18n
        >This field is required</span
    >
</div>
<div
    class="texareawrapper"
    [ngClass]="
        FormControl.invalid && (FormControl.dirty || FormControl.touched)
            ? 'error'
            : ''
    "
>
    <textarea
        #textareaEl
        [formControl]="FormControl"
        [placeholder]="placeholder"
        [attr.disabled]="disabled ? true : null"
        [attr.maxlength]="
            limitCharacters !== undefined ? limitCharacters : null
        "
        rows="1"
        (input)="chekValue(); resizeTextarea()"
        [style]="
            maxheight
                ? 'max-height:' + maxheight + '; min-height:' + minheight + ';'
                : 'min-height:' + minheight + ';'
        "
    ></textarea>
    <!-- <textarea
    #textareaEl
    [formControl]="FormControl"
    [placeholder]="placeholder"
    [attr.disabled]="disabled ? true : null"
    (keyup)="chekValue()"
  ></textarea> -->
</div>
